/**
 * Site Configuration - Marine Sealink B.V.
 * Single source of truth for business identity, contact details, and the
 * spare-parts category catalogue. Import from here instead of hardcoding
 * contact info or the Web3Forms access key in individual components.
 */

export const SITE = {
  name: 'Marine Sealink B.V.',
  shortName: 'Marine Sealink',
  tagline: 'Precision Automation & Control Systems Spares',
  description:
    'Specialized supplier of marine spare parts: electrical spares, instrumentation & control, OWS & ODME spares, and fire & smoke detection systems for vessels worldwide.',
  url: 'https://marine-sealink.com',
  email: 'contact@marine-sealink.com',
  phoneDisplay: '+31 6 87334469',
  phoneHref: 'tel:+31687334469',
  whatsappNumber: '31687334469',
  whatsapp: 'https://wa.me/31687334469',
  linkedin: 'https://www.linkedin.com/company/marine-sealink',
  location: 'Rotterdam, Netherlands',
  kvk: '87191512',
  vat: 'NL864230035B01',
  logo: '/img/Logo-Full_White.png',
  // Web3Forms access key (public by design; identifies the destination inbox).
  web3formsKey: 'd45bbfb5-4eb4-4bce-8f4e-bca69e776a03',
};

/**
 * The four spare-parts categories. Used by the navbar dropdown, homepage
 * services grid, footer links, and structured data. Each `path` has a
 * dedicated page under src/pages/.
 */
export const CATEGORIES = [
  {
    key: 'electrical',
    icon: 'fa-solid fa-bolt',
    title: 'Electrical Spares',
    path: '/electrical-spares',
    image: '/img/electrical-spares.jpg',
    short: 'Marine-approved electrical components for power management and distribution.',
    brands: 'Schneider, ABB, Siemens, Terasaki',
  },
  {
    key: 'instrumentation',
    icon: 'fa-solid fa-gauge-high',
    title: 'Instrumentation & Control',
    path: '/instrumentation',
    image: '/img/instrumentation.jpg',
    short: 'Precision measurement sensors and automation controls for engine room operations.',
    brands: 'Danfoss, WIKA, Emerson, Yokogawa',
  },
  {
    key: 'ows-odme',
    icon: 'fa-solid fa-oil-well',
    title: 'OWS & ODME Spares',
    path: '/ows-odme',
    image: '/img/port-aerial.jpg',
    short: 'Certified spares for strict compliance with MARPOL environmental regulations.',
    brands: 'Deckma Hamburg, Rivertrace, JOWA',
  },
  {
    key: 'fire-smoke',
    icon: 'fa-solid fa-fire-extinguisher',
    title: 'Fire & Smoke Detectors',
    path: '/fire-smoke',
    image: null,
    short: 'Safety replacements for marine addressable and conventional alarm systems.',
    brands: 'Consilium, Salwico, Autronica, Apollo',
  },
];

const siteConfig = { SITE, CATEGORIES };
export default siteConfig;
